import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'

export const useDeleteBookingApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async (bookingId: Params.DeleteBooking) => {
      const {data} = await ventrata.delete<Ventrata.Booking>(`/bookings/${bookingId}`, {
        headers: {
          'Octo-Capabilities': '',
        },
      })
      return data
    },
    [ventrata]
  )
}
